<template>
    <v-container grid-list-xs>
        <div>
            <v-row>
                <v-col>
                    <v-sheet class="pa-5" elevation="3">
                        <div v-if="status === 'pending'">
                            <h4 class="mb-2 primary--text">
                                {{ $t(`credit-increase.results.${status}.header`) }}
                            </h4>
                            <p>
                                {{ $t(`credit-increase.results.${status}.message`) }}
                            </p>
                        </div>

                        <div v-else-if="status !== 'error'">
                            <h4 class="mb-2 primary--text">
                                {{ $t(`credit-increase.results.${status}.header`) }}
                            </h4>
                            <p v-if="$te(`credit-increase.results.${status}.message`)">
                                {{
                                    $t(`credit-increase.results.${status}.message`, {
                                        creditLimit: formattedNewCreditLimit,
                                    })
                                }}
                            </p>

                            <ul class="body-1 bullet-styles pl-3 mt-4 mb-8">
                                <li>
                                    {{ $t("credit-increase.credit-line") }}:
                                    {{ creditLimitResultCents | currency }}
                                </li>
                                <li>
                                    {{ $t("credit-increase.available-credit") }}:
                                    {{ availableAmountCentsResultCents | currency }}
                                </li>
                                <li>
                                    {{ $t("credit-increase.treatment-total") }}:
                                    {{ treatmentAmountCents | currency }}
                                </li>
                            </ul>

                            <p>
                                <strong>{{ $t("credit-increase.whats-next") }}</strong>
                            </p>
                            <p v-if="$te(`credit-increase.results.${status}.whats-next-message`)">
                                {{ $t(`credit-increase.results.${status}.whats-next-message`) }}
                            </p>
                            <p v-if="$te(`credit-increase.results.${status}.decline-message`)">
                                <strong>
                                    {{ $t(`credit-increase.results.${status}.decline-message`) }}
                                </strong>
                            </p>
                        </div>
                        <div v-else>
                            <h4 class="mb-2 primary--text">There was an error processing your increase.</h4>
                        </div>

                        <v-row justify="center" class="mt-12">
                            <v-col class="text-right">
                                <Button class="secondary" rounded @click="done">
                                    {{ doneButtonText }}
                                </Button>
                            </v-col>
                        </v-row>
                    </v-sheet>
                </v-col>
            </v-row>
        </div>
    </v-container>
</template>

<script>
    import { mapState } from "vuex"
    import AutoFinishMixin from "@/components/apply/AutoFinishMixin"
    import FinishFlowAction from "@/action/actions/FinishFlowAction"
    import { workflowService } from "@/service"
    import { formatCurrency } from "@/util/currency"
    import { sessionState } from "@/state"
    import FlowType from "@/model/flow/FlowType"

    export default {
        mixins: [AutoFinishMixin],

        computed: {
            ...mapState("application", {
                treatmentAmountCents: state => state.data.purchaseAmountCents || 0,
            }),
            ...mapState("account", {
                availableAmountCents: state => state.data.availableAmountCents || 0,
                creditLimitCents: state => state.data.creditLimitCents || 0,
                newCreditLimitCents: state => state.data.newCreditLimitCents || 0,
                creditLimitChangeResponse: state => state.data.creditLimitChangeResponse,
            }),

            formattedNewCreditLimit() {
                return formatCurrency(this.newCreditLimitCents)
            },

            status() {
                const responseCode = this.creditLimitChangeResponse?.responseCode

                if (responseCode !== "success") {
                    return responseCode
                }

                if (this.creditLimitResultCents < this.newCreditLimitCents) {
                    return "partially-approved"
                }

                return "fully-approved"
            },

            creditLimitResultCents() {
                return this.creditLimitChangeResponse?.creditLimitCents || this.creditLimitCents
            },
            availableAmountCentsResultCents() {
                return this.creditLimitChangeResponse?.availableAmountCents || this.availableAmountCents
            },

            doneButtonText() {
                return sessionState.flowType === FlowType.APPLY ? this.$t("action.close") : this.$t("action.finish")
            },
        },

        methods: {
            done() {
                if (sessionState.flowType === FlowType.APPLY) {
                    this.$router.push({ path: `/providers/${sessionState.providerKey}/paymentPlans` })
                } else {
                    workflowService.invoke(new FinishFlowAction())
                }
            },
        },
    }
</script>
